import React, { useState } from 'react';
import Step1 from './step-1';
import Step2 from './step-2';
import Step3 from './step-3';

const CompleteWorkshopAppointment: React.FC = () => {
  const [steps, setSteps] = useState('COMPLETE_WORKSHOP');
  const getContentUI = () => {
    switch (steps) {
      case 'COMPLETE_WORKSHOP':
        return <Step1 handleSteps={data => setSteps(data)} />;
      case 'PAYMENT_CONFIRMATION':
        return <Step2 handleSteps={data => setSteps(data)} />;
      case 'PAYMENT':
        return <Step3 />;
    }
  };
  return (
    <div className="flex flex-wrap max-w-[450px] w-[450px] gap-y-4 overflow-hidden">
      {getContentUI()}
    </div>
  );
};

export default CompleteWorkshopAppointment;
